import { useEffect, useState } from "react";

const navItems = [
  { id: "must-watch", label: "必看榜" },
  { id: "high-rated", label: "高分精选" },
  { id: "trending", label: "热门" },
  { id: "genres", label: "按类型" },
  { id: "new-releases", label: "新片" },
  { id: "guide", label: "观影指南" },
  { id: "faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "border-b border-transparent"
      }`}
    >
      <nav className="flex h-16 w-full items-center justify-between px-4 md:h-[68px] md:px-8">
        <a
          href="#top"
          className="flex cursor-pointer items-center gap-2.5"
          onClick={() => setMenuOpen(false)}
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-film-line text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold text-foreground-950">
            风驰影院
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="cursor-pointer rounded-md px-3 py-2 font-label text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-800"
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:flex">
          <a
            href="#must-watch"
            className="flex cursor-pointer items-center gap-1.5 rounded-md bg-accent-500 px-4 py-2 font-label text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-accent-600"
          >
            <i className="ri-fire-line"></i>
            本周必看
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <div className="grid grid-cols-2 gap-1.5">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer rounded-md bg-background-100 px-3 py-2.5 font-label text-sm text-foreground-800"
              >
                {item.label}
              </a>
            ))}
          </div>
          <a
            href="#must-watch"
            onClick={() => setMenuOpen(false)}
            className="mt-2 flex cursor-pointer items-center justify-center gap-1.5 rounded-md bg-accent-500 px-4 py-2.5 font-label text-sm font-medium text-background-50 whitespace-nowrap"
          >
            <i className="ri-fire-line"></i>
            查看本周必看榜
          </a>
        </div>
      )}
    </header>
  );
}